export default __webpack_public_path__ + "static/media/vic-2.6573d04b.webp";